import config from './config';
import firebase from '@firebase/app';
import '@firebase/auth';
import '@firebase/database';
import store from './store'

firebase.initializeApp(config.firebase)

const loginWithEmailPassword = (email, password) => {
    return new Promise((resolve, reject) => {
	    return firebase.auth().signInWithEmailAndPassword(email, password).then((res) => {
			resolve(res);
		}).catch(error => {
			reject(error);
	    })
    })
}

const registerWithEmailPassword = (email, password) => {
	return new Promise((resolve, reject) => {
		firebase.auth().createUserWithEmailAndPassword(email, password).then((res) => {
			resolve(res);
		}).catch((error) => {
			reject(error);
		});
	});
}

const registerAnonymously = () => {
	return new Promise((resolve, reject) => {
		return firebase.auth().signInAnonymously().then((res) => {
			resolve(res);
		}).catch((error) => {
			let errorCode = error.code;
			let errorMessage = error.message;
			console.log("Error code: "+errorCode);
			console.log(errorMessage);
			reject(error);
		});
	});
}

const upgradeAnonymousUser = (email, password) => {
	let credential = firebase.auth.EmailAuthProvider.credential(email, password);
	return new Promise((resolve, reject) => {
		firebase.auth().currentUser.linkAndRetrieveDataWithCredential(credential).then((res) => {
			firebase.database().ref(`profiles/${res.user.uid}/email`).set(res.user.email).then(() => {
				firebase.database().ref(`profiles/${res.user.uid}`).once('value').then((snap)	 => {
					store.commit('profile', snap.val());
				});
			});
			resolve(res)
		}).catch((error) => {
			reject(error);
		});
	});
}


export default {
	loginWithEmailPassword: loginWithEmailPassword,
	registerWithEmailPassword: registerWithEmailPassword,
	registerAnonymously: registerAnonymously,
	upgradeAnonymousUser: upgradeAnonymousUser,
    currentUser() {
        return firebase.auth().currentUser;
	},
	getUserData() {
		if (!firebase.auth().currentUser) return
		let authID = firebase.auth().currentUser.uid;
		console.log("<<<<<< GET DATA FOR: "+authID)
		// GET ALL SURVEY DATA FOR USER
		return new Promise((resolve, reject) => {
			firebase.database().ref(`polls/${authID}`).once('value').then((snap) => {
				store.commit('userData', snap.val());
				resolve(authID)
			}).catch((error) => {
				reject(error);
			})
		})
	},
	getSurveyData() {
		console.log("<<<<<< LOAD SURVEY DATA FOR")
		return new Promise((resolve, reject) => {
			firebase.database().ref(`surveys`).once('value').then((snap) => {
				console.log(snap.val());
				resolve(snap.val())
			}).catch((error) => {
				reject(error);
			})
		})
	},
	signout() {
		firebase.auth().signOut().then(() => {
			//document.location = '/'
		})
	},
	adminSignout() {
		firebase.auth().signOut().then(() => {
		})
	},
	isAuth() {
		var user = firebase.auth().currentUser;
		var jwt = localStorage.getItem('id_token')
		if(user) {
			return true
		}
		else {
			return false
		}
  	},
	init() {
		return new Promise((resolve, reject) => {

            firebase.auth().onAuthStateChanged((user) => {

				// if we have a user we want to update the profile
				// with the doc in firestore
				if (user) {

					console.log('Auth state change: ', user.email)
					console.log('User UID: ', user.uid)
					if (!user.name) user.name = null

					// look to see if we have created a profile if not
					// then make one insert some basic profile details.

					// note this is not the same as the firebase auth user.
					firebase.database().ref(`profiles/${user.uid}`).once('value').then((snap)	 => {
						
						// if the profile is empty we need to create one
						if (!snap.val()) {
							
							snap.ref.set({
								created_at: firebase.database.ServerValue.TIMESTAMP,
								email: user.email,
								uid: user.uid,
								name: user.name
							}, () => {
								store.commit('authenticated', true);
								store.commit('profile', {
									created_at: new Date(),
									email: user.email,
									uid: user.uid,
									name: user.name
								});
								resolve(user);
							})
						} 
						
						// store the profile in the store and resolve
						else {
							store.commit('profile', snap.val());
							store.commit('authenticated', true);
							resolve(user);
						}
						
					}).catch((err) => {
						console.log(err);
					})

					// getIdToken().then((idToken) => {
					// 	localStorage.setItem('id_token', idToken)
					// 	store.commit('authenticated', true);
					// 	// console.log('auth id token', idToken);
					// 	resolve(true)
					// }).catch(err => {
					// 	console.log('ID Token Error: ', err);
					// })
				
				} else {
					console.log('no user authenticated');
					store.commit('authenticated', false);
					resolve(null)
				}
			})
		})
	}

}
